<template>
  <div class="switchBar">
    <el-tabs
      v-model="activeName"
      type="card"
      class="demo-tabs"
      @tab-click="handleClick"
    >
      <el-tab-pane label="待审核" name="first"></el-tab-pane>
      <el-tab-pane label="通过" name="second"></el-tab-pane>
      <el-tab-pane label="不通过" name="third"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="标题" prop="gameTitle" />
      <el-table-column label="语言" prop="gameLanguage" />
      <el-table-column label="单人/多人" prop="gameClass" />
      <el-table-column label="创建时间" prop="createTime" />
      <el-table-column
        label="备注"
        prop="remark"
        v-if="activeName == 'third'"
      />
      <el-table-column align="right">
        <template #default="scope">
          <el-button
            v-if="activeName == 'first'"
            type="warning"
            size="small"
            @click="
              handleEdit(scope.$index, scope.row);
              centerDialogVisible = true;
            "
            >审核</el-button
          >
          <el-button
            v-if="activeName == 'second'"
            type="danger"
            size="small"
            @click="quash(scope.$index, scope.row)"
            >撤销</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>

  <el-dialog
    v-model="centerDialogVisible"
    title=""
    width="900"
    center
    draggable
  >
    <div>
      <p>游戏标题：{{ form.gameTitle }}</p>
      <br />
      <p>游戏价格：{{ form.purchaseMoney }}元</p>
      <br />
      <p>游戏创作者：{{ form.author }}</p>
      <br />
      <p>
        游戏标签：<b
          v-for="item in JSON.parse(form.tips)"
          style="
            background: yellow;
            padding: 0.2em;
            margin: 0.2em;
            border: 1px solid #867f7f;
          "
          >{{ item }}</b
        >
      </p>
      <br />
      <p>游戏简介：{{ form.gameDesc }}</p>
      <br />
      <p>研学特点：{{ form.features }}</p>
      <br />
      <p>游戏语言：{{ form.gameLanguage }}</p>
      <br />
      <p>游戏模式：{{ form.gameClass }}</p>
      <br />
      <p>游戏难度：{{ form.difficulty }}星</p>
      <br />
      <p>开始点：{{ form.beginPoint }}</p>
      <br />
      <p>结束点：{{ form.endPoint }}</p>
      <br />
      <p>预估时间：{{ form.estimateTime }}</p>
      <br />
      <p>体验时间：{{ form.experienceTime }}</p>
      <br />
      <p>游玩人数：{{ form.multiplayer }}</p>
      <br />
      <p>适宜年龄：{{ form.playerAge }}</p>
      <br />
      <p>
        故事背景：<el-button
          type="info"
          @click="showLevel2"
          style="margin: 10px"
          >点击查看</el-button
        >
      </p>
      <p>
        内容编辑：<el-button type="info" @click="showLevel" style="margin: 10px"
          >点击查看</el-button
        >
      </p>

      <p>
        游戏复盘：<el-button
          type="info"
          @click="showLevel3"
          style="margin: 10px"
          >点击查看</el-button
        >
      </p>
      <br />
      <p>开放时间：{{ form.openHour }}</p>
      <br />
      <p style="display: flex; justify-content: start; align-items: start">
        <span>游学证明：</span>
        <el-image
          style="width: 200px; height: 400px"
          v-if="form.proveImg != null"
          :src="form.proveImg"
          :fit="'contain'"
        />
      </p>
      <br />
      <p>
        调查问卷：<a
          :href="form.feedbackLink"
          target="_blank"
          style="color: #2da8e0"
          >{{ form.feedbackLink }}</a
        >
      </p>
      <br />
      <p>创建时间：{{ form.createTime }}</p>
      <br />

      <p>游玩时间：{{ form.playTime }}分钟</p>
      <br />
      <p style="display: flex; justify-content: start; align-items: start">
        <span>游戏封面：</span>
        <el-image
          style="width: 200px; height: 200px"
          :src="form.gameCover"
          :fit="'contain'"
        />
      </p>
      <br />
      <p style="display: flex; justify-content: start; align-items: start">
        <span>自定义地图：</span>
        <el-image
          style="width: 200px; height: 200px"
          :src="form.customizeMap"
          :fit="'contain'"
        />
      </p>
    </div>

    <el-dialog v-model="startVisible" title="" width="500" center draggable>
      <div>
        <p>标题：{{ form3.startTitle }}</p>
        <br />
        <p>内容：{{ form3.startContent }}</p>
        <br />
        <p style="display: flex; justify-content: start; align-items: start">
          <span>地图：</span>
          <el-image
            style="width: 200px; height: 200px"
            :src="form3.startImg"
            :fit="'contain'"
          />
        </p>
        <br />
      </div>
    </el-dialog>

    <el-dialog v-model="endVisible" title="" width="500" center draggable>
      <div>
        <p>标题：{{ form3.endTitle }}</p>
        <br />
        <p>内容：{{ form3.endContent }}</p>
        <br />
        <p style="display: flex; justify-content: start; align-items: start">
          <span>地图：</span>
          <el-image
            style="width: 200px; height: 200px"
            :src="form3.endImg"
            :fit="'contain'"
          />
        </p>
        <br />
      </div>
    </el-dialog>
    <el-dialog v-model="levelVisible" width="700" title="关卡" append-to-body>
      <div>
        <el-collapse>
          <el-collapse-item
            v-for="item2 in form2"
            :title="item2.levelTitle"
            :name="item2.levelTitle"
          >
            <p>地址：{{ item2.address }}</p>
            <br />
            <p>经度：{{ item2.lat }}，纬度：{{ item2.lng }}</p>
            <br />
            <p>地址提示内容：{{ item2.addressTipContent }}</p>
            <br />
            <p>地址提示名称：{{ item2.addressTipName }}</p>
            <br />
            <p
              style="
                display: flex;
                justify-content: start;
                align-items: start;
                flex-wrap: wrap;
              "
            >
              <span>关卡位置提示图：</span>
              <el-image
                v-for="item3 in item2.tipCover.split(',')"
                v-if="item2.tipCover !== null"
                style="width: 100px; height: 100px; margin-left: 10px"
                :src="item3"
                :fit="'contain'"
              />
            </p>
            <br />

            <p>故事标题：{{ item2.storyTitle }}</p>
            <br />
            <p>故事内容：{{ item2.storyDesc }}星</p>
            <br />
            <p
              style="display: flex; justify-content: start; align-items: start"
            >
              <span>故事图片：</span>
              <el-image
                style="width: 200px; height: 200px"
                :src="item2.storyCover"
                :fit="'contain'"
              />
            </p>
            <br />
            <p>
              选择题：<b
                v-for="item3 in JSON.parse(item2.questions)"
                style="text-indent: 10%"
              >
                <i style="display: block">问题:{{ item3.value }}</i>
                <i style="display: block">正确答案:{{ item3.rightAnswer }}</i>
                <i
                  style="display: block; text-indent: 15%"
                  v-for="(item4, index4) in item3.options"
                >
                  <p>{{ index4 + 1 }}、{{ item4.one }}</p>
                </i>
                <br />
              </b>
            </p>
            <br />
            <p>难度：{{ item2.difficulty }}星</p>
            <br />
            <p>关卡内容：{{ item2.levelContent }}</p>
            <br />
            <p
              style="display: flex; justify-content: start; align-items: start"
            >
              <span>关卡谜题内容：</span>
              <el-image
                style="width: 200px; height: 200px"
                :src="item2.levelCover"
                :fit="'contain'"
              />
            </p>
            <br />
            <p>关卡答案：{{ item2.levelDesc }}</p>
            <br />
            <p>
              提示列表：<el-button
                type="info"
                @click="showTips(item2.tips)"
                style="margin: 10px"
                >点击查看</el-button
              >
            </p>
            <br />

            <p>景点标题：{{ item2.attractionsTitle }}</p>
            <br />
            <p>景点内容：{{ item2.attractions }}</p>
            <br />
            <p
              style="display: flex; justify-content: start; align-items: start"
            >
              <span>景点图片：</span>
              <el-image
                style="width: 200px; height: 200px"
                :src="item2.attractionsImage"
                :fit="'contain'"
              />
            </p>
            <br />
          </el-collapse-item>
        </el-collapse>
      </div>

      <el-dialog v-model="tipVisible" width="500" title="提示" append-to-body>
        <div>
          <el-collapse>
            <el-collapse-item
              v-for="item4 in form4"
              :title="item4.tipTitle"
              :name="item4.tipTitle"
            >
              <p>提示标题：{{ item4.tipTitle }}</p>
              <br />
              <p>提示内容：{{ item4.tipContent }}</p>
              <br />
              <p
                style="
                  display: flex;
                  justify-content: start;
                  align-items: start;
                "
              >
                <span>提示图片：</span>
                <el-image
                  v-if="item4.tipPicture != null"
                  style="width: 200px; height: 200px"
                  :src="item4.tipPicture"
                  :fit="'contain'"
                />
              </p>
              <br />
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-dialog>
    </el-dialog>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="noPass">不通过</el-button>
        <el-button type="primary" @click="pass"> 通过 </el-button>
      </div>
    </template>
  </el-dialog>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
} from "@element-plus/icons-vue";
import { ElMessageBox, TabsPaneContext } from "element-plus";
import { Form, GameData } from "@/views/view";
export default defineComponent({
  name: "App",
  data(): any {
    return {
      currentPage: 1,
      total: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "first",
      tableData: [],
      status: 0,
      centerDialogVisible: false,
      levelVisible: false,
      startVisible: false,
      endVisible: false,
      tipVisible: false,
      form: {
        along: "",
        author: null,
        beginPoint: "",
        belongId: "",
        carousel: null,
        createTime: "",
        customizeMap: "",
        difficulty: 3,
        endPoint: "",
        estimateTime: "",
        experienceTime: "",
        features: "",
        feedbackLink: "",
        gameClass: "",
        gameCover: "",
        gameDesc: "",
        gameLanguage: "",
        gameLevelId: "",
        gameTitle: "",
        id: "",
        integralId: "",
        latitude: 0,
        longitude: 0,
        mapSelect: "",
        multiplayer: "",
        openHour: "",
        playTime: 0,
        playerAge: "",
        proveImg: null,
        publicStatus: 1,
        releaseTime: "",
        remark: "",
        status: 0,
        tips: "",
        transportation: "",
        updateTime: "",
        version: 0,
        walk: "",
      },
      form2: [],
      form3: {
        createTime: "",
        endContent: "",
        endImg: "",
        endTitle: "",
        gameId: "",
        id: "",
        startContent: "",
        startImg: "",
        startTitle: "",
      },
      form4: [],
    };
  },
  components: {
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.gameCover !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {},
  created() {
    this.fetchGameList(this.currentPage, this.status);
  },
  methods: {
    fetchGameList(pageNum: number, status: number) {
      const pageSize = 10;
      this.$store
        .dispatch("game/getGameList2", { pageNum, pageSize, status })
        .then((res: any) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err: any) => {});
    },
    handleCurrentChange(val: number) {
      this.fetchGameList(val, this.status);
    },
    handleEdit(index: number, row: Form) {
      this.form = row;
    },
    showLevel() {
      this.levelVisible = true;
      this.$store
        .dispatch("game/getGameLevelList2", {
          gameLevelId: this.form.gameLevelId,
        })
        .then((res: any) => {
          console.log(res);
          this.form2 = res;
        })
        .catch((err: any) => {});
    },
    showLevel2() {
      this.startVisible = true;
      this.$store
        .dispatch("game/getStory2", {
          gameId: this.form.id,
        })
        .then((res: any) => {
          this.form3 = res;
        })
        .catch((err: any) => {});
    },
    showLevel3() {
      this.endVisible = true;
      this.$store
        .dispatch("game/getStory2", {
          gameId: this.form.id,
        })
        .then((res: any) => {
          this.form3 = res;
        })
        .catch((err: any) => {});
    },
    showTips(tips: string) {
      this.tipVisible = true;
      this.$store
        .dispatch("game/getTipList2", {
          tips: tips,
        })
        .then((res: any) => {
          console.log(res);
          this.form4 = res;
        })
        .catch((err: any) => {});
    },
    proven() {},
    handleClick(tab: TabsPaneContext) {
      this.status =
        tab.paneName === "first" ? 0 : tab.paneName === "second" ? 1 : 2;
      this.fetchGameList(1, this.status);
    },
    noPass() {
      ElMessageBox.prompt("请输入失败原因", "Tip", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.updateGame(this.form.id, 2, value);
        })
        .catch(() => {});
    },
    pass() {
      this.updateGame(this.form.id, 1);
    },
    quash(index: number, row: Form) {
      this.updateGame(row.id, 0);
    },
    updateGame(releaseId: string, status: number, remark = "") {
      this.$store
        .dispatch("game/updateRelease", {
          releaseId: releaseId,
          status: status,
          remark: remark,
        })
        .then(() => {
          this.handleCurrentChange(this.currentPage);
        })
        .catch(() => {});
      this.centerDialogVisible = false;
    },
  },
});
</script>

<style lang="less" scoped>
.switchBar {
  width: 100%;
  height: auto;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
